import React from 'react'
import { object, string } from 'yup'
import { useTranslation } from 'react-i18next'
import { Draft, FloorplanWorkspaceData } from 'zens-store'
import { StyleSheet } from 'react-native'
import { observer } from 'mobx-react'

import { Form, FormProps } from '..'

const styles = StyleSheet.create({
  form: {
    width: 360,
  },
})

interface Props extends Omit<FormProps, 'draft' | 'config' | 'schema' | 'buttons'> {
  draft: Draft<FloorplanWorkspaceData>
  onSave?: (draft: Draft<FloorplanWorkspaceData>) => Promise<void>
  onCancel?: (draft: Draft<FloorplanWorkspaceData>) => Promise<void>
  onRemove?: (draft: Draft<FloorplanWorkspaceData>) => void
  onError?: (errors?: Record<string, string>) => void
}
const WorkspaceForm = (props: Props) => {
  const { draft, errors, onSave, onCancel, onRemove, style, ...otherProps } = props
  const { t } = useTranslation()

  const config = {
    groups: [
      {
        fields: [
          {
            key: 'name',
            label: t('Workspace name'),
          },
        ],
      },
    ],
  }
  const schema = object({
    name: string().required(t('Workspace name is required')),
  })
  const buttons = [
    [
      {
        title: t('Save'),
        onPress: async () => onSave?.(draft),
        validate: true,
        contentContainerStyle: {
          minWidth: 120,
        },
      },
      {
        title: t('Cancel'),
        onPress: async () => onCancel?.(draft),
        light: true,
        contentContainerStyle: {
          minWidth: 120,
        },
      },
      {
        left: 'trash' as const,
        onPress: async () => onRemove?.(draft),
        danger: true,
        contentContainerStyle: {
          minWidth: 40,
        },
      },
    ],
  ]
  return (
    <>
      <Form
        draft={draft}
        config={config}
        schema={schema}
        buttons={buttons}
        style={[styles.form, style]}
        errors={errors}
        {...otherProps}
      />
    </>
  )
}

export default observer(WorkspaceForm)
